import groq from "groq"

import { AppSettings } from "@/settings"

import { groqBranchOfficeProjection } from "../sanity/branchOffice.projection"

export async function getBranchOfficeById(lang, context, cdn, id) {
  const config = AppSettings.sanityConfigByLang(lang)
  const client = context.sanityClient
  client.config({ ...config, useCdn: cdn })

  const draftsFilter = `&& !(_id in path("drafts.**"))`

  const branchOffice = await client.fetch(
    groq`*[_type=="branchOffice" && id==$id ${draftsFilter}][0] {
          ...,
          ${groqBranchOfficeProjection()}
        }`,
    { id },
  )

  return branchOffice || null
}

export async function getBranchOfficesTitle(lang, context, cdn) {
  const config = AppSettings.sanityConfigByLang(lang)
  const client = context.sanityClient
  client.config({ ...config, useCdn: cdn })

  const draftsFilter = `&& !(_id in path("drafts.**"))`
  const branchOffices = await client.fetch(
    groq`
      *[_type=="branchOffice" ${draftsFilter}] {
          id,
          title,
      }`,
  )

  return branchOffices
}
